<template>
  <div class="welcome wbg">
    <!-- <div class="fixtp" v-if="$common.AUTH('0-1')">
      <a href="javascript:void(0);" @click='seeIn(3)'>即将到期保全记录({{Num}})</a>
    </div> -->
    <TableBox ref='fabox' :type='seeType' :title='seeTitle'></TableBox>
    <div class="top" v-if='$common.AUTH("debtor:view")'>
      <a-row class="row" :gutter="40">
        <a-col class="flex" :span="6">
          <label>债务人：</label>
          <a-input placeholder='请输入债务人姓名' v-model='form.realname'> </a-input>
        </a-col>
        <a-col class="flex" :span="6">
          <label>债务人证件号码：</label>
          <a-input placeholder='请输入债务人证件号码' v-model='form.chinaid'></a-input>
        </a-col>
        <a-col class="flex" :span="6">
          <label>案号：</label>
          <a-input placeholder='请输入对应案号' v-model='form.no'></a-input>
        </a-col>
        <a-col class="flex" :span="6">
          <a-button type="primary" icon="search" @click='form.page = 1; getList()'
            style="margin-right:20px;height:32px;">查询</a-button>
          <a-button @click='reset' style="margin-right:20px;height:32px;">重置</a-button>
          <router-link v-if="$common.AUTH('debtor:add')" :to='{ "name": "newly" }' tag="span">
            <a-button icon="plus" class="blu" style="height:32px;">
              新增
            </a-button>
          </router-link>
        </a-col>
      </a-row>
    </div>
    <div class="tcon">
      <div class="tableList" v-if='$common.AUTH("debtor:view")'>
        <div class="table">
          <table>
            <thead>
              <td width='54'>序号</td>
              <td width='72'>债务人</td>
              <td width='130'>债务人证件号码</td>
              <td width="60">所属案件</td>
              <td width="210">原告</td>
              <td width='190'>案号</td>
              <td width='186'>管辖法院</td>
              <td width='108' style="padding-left:30px;">录入日期</td>
              <!-- <td width='74'>操作</td> -->
            </thead>
            <tbody>
              <tr v-for='(i, index) in data' :key='index'>
                <td>{{ 10 * (form.page - 1) + index + 1 }}</td>
                <td><span class="curpoter" @click='dbclick(i)'> {{ i.realname }}</span></td>
                <td>{{ i.chinaid }}</td>
                <td>
                  <p v-for='(j, index) in i.cause' :key="index">
                    案件{{ j.sort }}
                  </p>
                </td>
                <td>
                  <p v-for='(j, index) in i.cause' :key="index">
                    <Normap :tit='j.accuser.title'>{{ j.accuser.title }}</Normap>
                  </p>
                </td>
                <td>
                  <p v-for='(j, index) in i.cause' :key="index">
                    <span v-if='j.no'>
                      <Normap :tit='j.no'>{{ i.no }}</Normap>
                    </span>
                    <span v-else>/</span>
                  </p>
                </td>
                <td>
                  <p v-for='(j, index) in i.cause' :key="index">
                    <span v-if='j.court'>
                      <Normap :tit='j.court'>{{ j.court }}</Normap>
                    </span>
                    <span v-else>/</span>
                  </p>
                </td>
                <td style="padding-left:30px;">{{ i.create_time | yearFormat }}</td>
                <!-- <td>
                  <a href="javascript:vold(0);" @click='dbclick(i)'>查看</a>
                </td> -->
              </tr>
            </tbody>
          </table>

        </div>
        <div class="pages">
          <a-pagination v-model="form.page" show-quick-jumper :total="total" show-less-items :pageSize='10'
            @change='turnpage' :show-total="(total) => `债务人：${total} 案件数：${cause_count}`" />
        </div>
      </div>
      <div class="nqx" v-else>您没有该页面的访问权限，请联系管理员开通。</div>
    </div>
    <a-modal v-model="modalVisible" title="选择导出类型" width="500px" centered>
      <div class="change-download">
        <a-row>
          <a-col :span="19">
            <p>确认债权</p>
          </a-col>
          <a-col>
            <a-button icon='upload' @click="download('/export/qrzq')">导出</a-button>
          </a-col>
        </a-row>
        <a-row>
          <a-col :span="19">
            <p>主张债权</p>
          </a-col>
          <a-col>
            <a-button icon='upload' @click="download('/export/zzzq')">导出</a-button>
          </a-col>
        </a-row>
        <a-row>
          <a-col :span="19">
            <p>裁判文书</p>
          </a-col>
          <a-col>
            <a-button icon='upload' @click="download('/export/cpws')">导出</a-button>
          </a-col>
        </a-row>
        <a-row>
          <a-col :span="19">
            <p>案件费用缴纳</p>
          </a-col>
          <a-col>
            <a-button icon='upload' @click="download('/export/ssfyjn')">导出</a-button>
          </a-col>
        </a-row>
        <a-row>
          <a-col :span="19">
            <p>开庭情况</p>
          </a-col>
          <a-col>
            <a-button icon='upload' @click="download('/export/ktqk')">导出</a-button>
          </a-col>
        </a-row>
        <a-row>
          <a-col :span="19">
            <p>开庭计划</p>
          </a-col>
          <a-col>
            <a-button icon='upload' @click="download('/export/ktjh')">导出</a-button>
          </a-col>
        </a-row>
        <a-row>
          <a-col :span="19">
            <p>案件信息</p>
          </a-col>
          <a-col>
            <a-button icon='upload' @click="download('/export/ssxx')">导出</a-button>
          </a-col>
        </a-row>
      </div>
      <div slot="footer" class="modal-footer">
        <a-button type="primary" class="cancel" @click="modalVisible = false">关闭</a-button>
      </div>
    </a-modal>
  </div>
</template>
<script>
import { Tacitly } from '@/assets/js/Tacitly'
import TableBox from "@/components/table"
import { getAccuserAll } from '@/server/api'
export default {
  data() {
    return {
      data: [],
      modify: null,
      time: null,
      page: {
        current: 1,
        pageSize: 10,
        showQuickJumper: true,
        showSizeChanger: false,
        total: 0
      },
      accuserList: [],
      form: {
        accuser_id: [],
        team_id: '',
        limit: 10,
        page: 1,
        realname: '',
        chinaid: '',
        no: '',
        stime: '',
        etime: '',
      },
      total: 0,
      cause_count: 0,
      modalVisible: false,
      Num: 0,
      seeType: 0,
      seeTitle: ''
    }
  },
  created() {
    this.getList()
    this.getOverNum()
  },
  computed: {
    teamList() {
      return this.form.accuser_id.length > 1 || this.form.accuser_id.length == 0 ? [] : this.accuserList.find(ele => {
        return ele.id === this.form.accuser_id[0]
      }).team
    }
  },
  components: {
    TableBox
  },
  mounted() {
    // console.log(this.$store.state)


    let _this = this
    document.onkeydown = function (e) {//条件搜索和选择分页后，回车请求列表数据，感觉没必要，会多请求一次第一页
      if (e.keyCode == 13) {
        _this.getList()
      }
    }
    getAccuserAll().then((res) => {
      this.accuserList = res.list
    })
    if (this.$route.query.see) {
      this.seeIn(3)
    }
  },
  methods: {
    reset() {
      this.form.limit = 10
      this.form.page = 1
      this.form.realname = ''
      this.form.chinaid = ''
      this.form.no = ''
      this.form.page = 1
      this.getList()
    },
    ckAcc(val) {
      if (val.length > 1 || val.length == 0) {
        this.form.team_id = ''
      }
    },
    seeIn(index) {
      this.seeType = index;
      this.$refs.fabox.visible = true;
      this.seeTitle = "即将到期保全记录"
    },
    getOverNum() {
      this.$store.dispatch("Case/getdebtorExpire", { limit: 10, page: 1 }).then(e => {
        this.Num = e.count
      })
    },
    turnpage(val) {
      // console.log('页脚',val);

      this.form.page = val;
      this.getList({ current: val })
    },
    dbclick(record) {
      if (this.$common.AUTH('debtor:info')) {
        let routeUrl = this.$router.resolve({ "name": "lydetails", params: { "id": record.id } });
        window.open(routeUrl.href, '_blank');
      }
      else {
        this.$message.error({ content: '暂无权限', key: 'updatable' });
      }
    },
    getList(val) {
      let form = JSON.parse(JSON.stringify(this.form))
      if (typeof val === 'object') {
        this.page.current = val.current
        form.page = val.current
      } else {
        this.page.current = 1
        form.page = 1
      }

      form.accuser_id = form.accuser_id.toString()
      this.$Ajax({
        url: 'debtor/lists',
        type: "get",
        data: form,
        success: (e) => {
          this.total = e.count
          this.cause_count = e.cause_count
          // console.log(e)
          e.list.map(ele => {
            ele.fee = ele.fee / 100
          })
          this.data = e.list
          this.page.total = e.count
        }
      })
    },
    PickTime(e) {
      if ("stime" in e) {
        this.form.stime = e.stime
      }
      else {
        this.form.etime = e.etime
      }
    },
    download(url) {
      // let http = process.env.NODE_ENV == "development" ? "" : "http://www.xyfxglxt.com/index.php/api/"
      let http = Tacitly.Base_Port
      this.$modal.confirm({
        content: '确认导出这个文件？',
        onOk: () => {
          window.open(http + url + '?realname=' + (this.form.realname ? this.form.realname : '') + '&chinaid=' + (this.form.chinaid ? this.form.chinaid : '') + '&no=' + (this.form.no ? this.form.no : '') + '&stime=' + (this.form.stime ? this.form.stime : '') + '&etime=' + (this.form.etime ? this.form.etime : ''))
        }
      });
    }
  }
}
</script>
<style lang="less" scoped>
.nowrap {
  white-space: nowrap;
}

.fixtp {
  position: absolute;
  top: -45px;
  right: 20px;
  z-index: 11;

  a {
    margin-left: 20px;
    padding: 0 20px;
    line-height: 30px;
    display: inline-block;
    border-radius: 6px;
    border: #f5222d 1px solid;
    color: #ff4d4f;

    &:hover {
      background: #ff4d4f;
      color: #fff;
    }
  }
}

.welcome::-webkit-scrollbar {
  display: none;
  /* WebKit */
  overflow: hidden !important;
}

.welcome {
  position: relative;

  .top {
    @import url('@/assets/css/search.less');
  }

  .tableList {
    margin-top: 20px;
    width: 100%;

    .table {
      thead {
        td {
          padding-left: 0;

          &:nth-child(1) {
            padding-left: 20px;
          }
        }
      }

      tbody {
        tr:nth-last-child(1) {
          border-bottom: 1px solid #ebebeb;
        }

        td {
          padding: 6px 0;
          height: 60px;

          &:nth-child(1) {
            padding-left: 20px;
          }

          &:nth-last-child(1) {
            padding-left: 10px;
          }

          p {
            padding: 10px 0;
            margin: 0;
            border-bottom: 1px solid #ebebeb;

            &:nth-last-child(1) {
              border: 0 none;
            }
          }
        }
      }
    }
  }

  .pages {
    text-align: right;
  }
}

.change-download {
  .ant-row {
    margin-bottom: 15px;
    line-height: 36px;

    p {
      margin: 0;
    }
  }
}
</style>
